import React, { Component } from 'react';
import { Col, FormGroup, Input, Label } from "reactstrap";

class PasswordSshkeyInputGroup extends Component {
    state = { usePassword: true };

    handlePasswordSshChange = () => {
        this.setState({ usePassword: !this.state.usePassword });
        this.props.resetInputs();
    }

    render() {
        return (
            <>
                <Col lg={this.props.lgColSize} sm={this.props.smColSize} xs={this.props.xsColSize}>
                    <FormGroup>
                        <Label htmlFor="password">
                            {this.state.usePassword ? 'Password' : 'SSH Key'} (click {" "}
                            <a onClick={this.handlePasswordSshChange} className="custom-link">here</a>
                            {" "} to use {this.state.usePassword ? 'ssh key' : 'password'})

                            {(this.props.confirmPassword !== this.props.password) && (
                                <span className="badge bg-danger"> Password does not match! </span>
                            ) }
                        </Label>
                        {this.state.usePassword ? (
                            <Input required type="password" name="password" autoComplete="off" defaultValue={this.props.password} onChange={this.props.handleInputChange} />
                        ) : (
                            <Input required type="text" name="ssh_key" defaultValue={this.props.ssh_key} onChange={this.props.handleInputChange} />
                        )}

                    </FormGroup>
                </Col>
                {this.state.usePassword && (
                    <Col lg={this.props.lgColSize} sm={this.props.smColSize} xs={this.props.xsColSize}>
                        <FormGroup>
                            <Label htmlFor="confirmPassword">Confirm Password</Label>
                            <Input required type="password" defaultValue={this.props.confirmPassword} name="confirmPassword" onChange={this.props.handleInputChange} />
                        </FormGroup>
                    </Col>
                )}


            </>
        )
    }
}

export default PasswordSshkeyInputGroup;
